import React, { useState } from "react";
import withForm from "withForm";
import dataProvider, { UPDATE } from "providers/dataProvider";
import { withNotificationCenter } from "NotificationCenter";
import { compose } from "redux";
import BaseInputList from "components/ui_components/BaseInputList/BaseInputList";
import { useNotificationCenter } from "NotificationCenter";
import { BaseWidgetViewList } from "components/ui_components/Widgets/WidgetViewLists";
import { clientICDNotesConfig } from "config/resources/requisitionsResource/billingTab";
import authStorage from "providers/authStorage";
import { userRoles } from "config/userRoles";
import WidgetType1 from "components/ui_components/Widgets/WidgetType1/WidgetType1";
import { ButtonGroup, WidgetControlButton } from "components/ui_components/buttons";

const ClientICDNotes = ({ legacyIcdNote, ...props }) => {
  const {
    reqData,
    inputsByHash,
    inputsById,
    handleInputs,
    getSubmitData,
    isFormValid,
    resetErrors,
    setReqDataByKey,
  } = props;

  const notificationCenter = useNotificationCenter();
  const [isEditMode, setEditMode] = useState(false);

  const handleSubmit = async () => {
    resetErrors();

    if (isFormValid())
      dataProvider(
        UPDATE,
        `requisitions/${reqData.id}/patient_hists/${reqData.patientHistId}`,
        { data: getSubmitData() }
      )
        .then(({ data, message }) => {
          notificationCenter.show(message, "info");
          setReqDataByKey(data, 'legacyIcdNote');
          setEditMode(false);
        })
        .catch((error) => {
          notificationCenter.show(error.message, "error");
        });
  };

  // Check if the current user has sales role
  const userRoleCode = authStorage.getAccess()?.userRoleCode;
  const isSalesRole = userRoleCode === userRoles.sales;

  // Custom controls with disabled styling for sales users
  const renderControls = () => {
    return (
      <ButtonGroup>
        {isEditMode && (
          <WidgetControlButton
            variant="outlined"
            onClick={() => setEditMode(false)}
          >
            Cancel
          </WidgetControlButton>
        )}

        {/* Custom button to match Duplicate This Requisition button with no hover effects */}
        {isSalesRole ? (
          <button
            style={{
              backgroundColor: '#8ea9be',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              padding: '6px 16px',
              textTransform: 'none',
              fontWeight: 'normal',
              fontSize: '14px',
              boxShadow: 'none',
              cursor: 'default',
              pointerEvents: 'none',  // Completely disable hover events
              margin: '0 4px' // Match ButtonGroup spacing
            }}
            disabled
          >
            {isEditMode ? "Save" : "Edit"}
          </button>
        ) : (
          <WidgetControlButton
            onClick={isEditMode ? handleSubmit : () => setEditMode(true)}
          >
            {isEditMode ? "Save" : "Edit"}
          </WidgetControlButton>
        )}
      </ButtonGroup>
    );
  };

  // Use WidgetType1 directly to customize the controls
  return (
    <WidgetType1
      title={"Client ICD Notes"}
      wrapStyles={`padding: 20px 0 0;`}
      content={isEditMode ? (
        <BaseInputList
          inputsByHash={inputsByHash}
          inputsById={inputsById}
          handleInputs={handleInputs}
        />
      ) : (
        <BaseWidgetViewList
          ids={clientICDNotesConfig.viewConfig.inputsById}
          inputsByHash={clientICDNotesConfig.viewConfig.inputsByHash}
          data={reqData}
          showIcons={false}
        />
      )}
      headerRightContent={renderControls()}
    />
  );
};

export default compose(withForm(), withNotificationCenter())(ClientICDNotes);
